// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__df5TJ","description":"MealItem_description__kARHs","price":"MealItem_price__L4q5n"};